import React, { useEffect, useState } from 'react';
import './ErrorPage.css';

interface ErrorPageProps {
  errorCode?: number;
  title?: string;
  message?: string;
}

const ErrorPage: React.FC<ErrorPageProps> = ({ 
  errorCode = 404, 
  title,
  message
}) => {
  const [glitchActive, setGlitchActive] = useState(false);

  // Glitch effect
  useEffect(() => {
    const glitchInterval = setInterval(() => {
      setGlitchActive(true);
      setTimeout(() => setGlitchActive(false), 200);
    }, 3000);
    return () => clearInterval(glitchInterval);
  }, []);

  const getErrorContent = () => {
    if (title && message) {
      return { title, message };
    }

    switch (errorCode) {
      case 404:
        return {
          title: 'Sayfa Bulunamadı',
          message: 'Aradığınız sayfa taşınmış veya hiç var olmamış olabilir.'
        };
      case 500:
        return {
          title: 'Sunucu Hatası',
          message: 'Bir şeyler ters gitti. Ekibimiz sorunu çözmek için çalışıyor!'
        };
      case 503:
        return {
          title: 'Servis Kullanılamıyor',
          message: 'Servisimiz şu anda bakımda. Lütfen biraz sonra tekrar deneyin.'
        };
      default:
        return {
          title: 'Hata Oluştu',
          message: 'Beklenmeyen bir hata oluştu. Lütfen tekrar deneyin.'
        };
    }
  };

  const content = getErrorContent();

  return (
    <div className="error-page-container">
      {/* Background decoration */}
      <div className="error-bg-shapes">
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
        <div className="shape shape-3"></div>
      </div>

      <div className="error-page-content">
        {/* Animated Error Code */}
        <div className={`error-code ${glitchActive ? 'glitch' : ''}`}>
          <span className="error-code-text" data-text={errorCode}>
            {errorCode}
          </span>
        </div>

        {/* Cute Illustration */}
        <div className="error-illustration">
          <div className="broken-hanger">
            <div className="hanger-hook"></div>
            <div className="hanger-body">
              <div className="hanger-arm left"></div>
              <div className="hanger-arm right broken"></div>
            </div>
            <div className="fallen-dress">
              <span className="dress-icon">👗</span>
            </div>
          </div>
        </div>

        {/* Message */}
        <h1 className="error-title">{content.title}</h1>
        <p className="error-message">{content.message}</p>

        {/* Action Button */}
        <div className="error-actions">
          <button className="primary-button" onClick={() => window.location.reload()}>
            <span className="button-icon">🔄</span>
            Sayfayı Yenile
          </button>
        </div>

        {/* Decorative Fashion Elements */}
        <div className="fashion-elements">
          <span className="fashion-icon icon-1">✂️</span>
          <span className="fashion-icon icon-2">🧵</span>
          <span className="fashion-icon icon-3">📏</span>
          <span className="fashion-icon icon-4">🎨</span>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;

